import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserState} from '../../api/models/user-state';
import {Subscription} from 'dexie';
import {GlobalApp} from '../../tools/global';
import {Router} from '@angular/router';
import {SubscriptionService} from '../../api/services/subscription.service';
import {MatSelectChange} from '@angular/material/select';
import {ConfirmDialogComponent} from '../../dialogs/confirm-dialog/confirm-dialog.component';
import {DialogResult, DialogResultType} from '../../dialogs/DialogResult';
import {MatDialog} from '@angular/material/dialog';
import {DataOnDemandService} from '../../api/services/data-on-demand.service';
import {DodEndPointEx} from '../../api/models/dod-end-point-ex';
import {DodLayoutEx} from '../../api/models/dod-layout-ex';
import {
  DataOnDemandLayoutDialogComponent,
  DataOnDemandLayoutDialogResult
} from '../../dialogs/data-on-demand-layout-dialog/data-on-demand-layout-dialog.component';
import {UserStateEx} from '../../api/models-ex/user-state-ex';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  RecurringDodDialogComponent,
  RecurringDodDialogResult,
  RecurringDodType
} from '../../dialogs/recurring-dod-dialog/recurring-dod-dialog.component';
import {DodRecurring} from '../../api/models/dod-recurring';
import {DodJobEx} from '../../api/models/dod-job-ex';
import {DataOnDemandDialogComponent, DataOnDemandDialogResult} from '../../dialogs/data-on-demand-dialog/data-on-demand-dialog.component';
import {DodExportStatus} from '../../api/models/dod-export-status';

@Component({
  selector: "app-data-layouts",
  templateUrl: "./data-layouts.component.html"
})
export class DataLayoutsComponent implements OnInit, OnDestroy {

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false
  };
  userStateSubscription: Subscription = null;

  public loadingData = false;
  public allEndPoints: DodEndPointEx[] = [];
  public allLayouts: DodLayoutEx[] = [];

  public selectedEndPoint: DodEndPointEx = null;
  public currentLayouts: LayoutDetails[] = [];
  public exportStatus: DodExportStatus[] = [];

  public refreshTimer: any = null;

  constructor(
    private app: GlobalApp,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private dodService: DataOnDemandService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      } else {
        this.app.getAuthorizationStatus().subscribe((result) => {
          this.app.refreshUserState(this.subscriptionService);
        });
      }
    });
  }

  ngOnInit() {

    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;
    });

    this.dodService.dataOnDemandGetUserAvailableDodEndPoints().subscribe(dodEndPoints => {
      this.allEndPoints = dodEndPoints;
    });

    this.dodService.dataOnDemandGetUserAvailableDodLayouts().subscribe(dodLayouts => {
      this.allLayouts = dodLayouts;
      this.selectedEndPoint = this.allEndPoints[0];
      if (this.selectedEndPoint) {
        this.currentLayouts = this.allLayouts
          .filter(x => x.dodEndPointId === this.selectedEndPoint.dodEndPointId)
          .map(x => {
            return {
              ...x,
              exportStatus: 'Never Ran',
              latestUrl: undefined
            }
        })
        this.refreshJobs();
      }
    });

    this.refreshTimer = setInterval(() => this.refreshJobs(), 5000);
    this.refreshJobs();
  }

  ngOnDestroy() {
    if (this.userStateSubscription) {
      this.userStateSubscription.unsubscribe();
    }

    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  refreshJobs() {
    let layoutIds = this.currentLayouts.map(x => x.dodLayoutId);
    this.dodService.dataOnDemandGetLatestLayoutJobStatus(layoutIds).subscribe(latestExports => {
      this.exportStatus = latestExports;
      this.updateJobs();
    });
  }

  refreshLayouts() {
    const endPointSelected = this.selectedEndPoint.dodEndPointId;
    this.dodService.dataOnDemandGetUserAvailableDodLayouts().subscribe(dodLayouts => {
      this.allLayouts = dodLayouts;
      this.selectedEndPoint = this.allEndPoints.find(x => x.dodEndPointId === endPointSelected);
      this.currentLayouts = this.allLayouts
        .filter(x => x.dodEndPointId === this.selectedEndPoint.dodEndPointId)
        .map(x => {
          return {
            ...x,
            exportStatus: 'Never Ran'
          }
        })
      this.updateJobs();
    });
  }

  updateJobs() {
    for(let i = 0; i < this.currentLayouts.length; i++) {
      let found = false;
      for(let e = 0; e < this.exportStatus.length; e++) {
        if (this.currentLayouts[i].dodLayoutId == this.exportStatus[e].dodLayoutId) {
          found = true;
          this.currentLayouts[i].exportStatus = this.getExportStatus(this.exportStatus[e]);
        }
      }
      if (!found) {
        this.currentLayouts[i].exportStatus = 'Never Ran';
      }
    }
  }

  createLayout() {
    let layout : DodLayoutEx = {
      subscriptionId: this.selectedEndPoint.subHeaders[0].subscriptionId,
      allowEditing: true,
      dodLayoutId: 0,
      filterData: undefined,
      isOwner: true,
      userId: 0,
      dodEndPointId: this.selectedEndPoint.dodEndPointId,
      fileTypeId: 0,
      deleted: false,
      destinationId: 0,
      emailConfig: { emailAddress: 'example@example.com' }
    };

    DataOnDemandLayoutDialogComponent.showDialog(
      this.dialog,
      this.selectedEndPoint,
      layout,
      UserStateEx.getDodLayoutShareState(this.userState, this.selectedEndPoint, layout),
      true
    ).subscribe(result => {
      if (result.ResultType === DialogResultType.Ok) {
        let resultData = result.ResultData as DataOnDemandLayoutDialogResult;
        this.dodService.dataOnDemandCreateDataOnDemandLayout(resultData.dodLayout).subscribe(dodLayoutId => {
          this.refreshLayouts();
          this.dodService.dataOnDemandUpdateDodLayoutSharing({dodLayoutId, updateSharingStatus: UserStateEx.getSharingStatus(resultData.shareState)}).subscribe(result => {
            this.snackBar.open("Layout '" + resultData.dodLayout.name + "' Created.", null, {
              duration: 5000
            });
          });
        });
      }
    })

    return false;
  }

  editLayout(layout: DodLayoutEx) {
    DataOnDemandLayoutDialogComponent.showDialog(
      this.dialog,
      this.selectedEndPoint,
      layout,
      UserStateEx.getDodLayoutShareState(this.userState, this.selectedEndPoint, layout),
      true
    ).subscribe(result => {
      if (result.ResultType === DialogResultType.Ok) {
        let resultData = result.ResultData as DataOnDemandLayoutDialogResult;
        this.dodService.dataOnDemandUpdateDataOnDemandLayout({dataOnDemandLayoutId: layout.dodLayoutId, request: resultData.dodLayout}).subscribe(dodLayoutId => {
          this.refreshLayouts();
          this.dodService.dataOnDemandUpdateDodLayoutSharing({dodLayoutId: layout.dodLayoutId, updateSharingStatus: UserStateEx.getSharingStatus(resultData.shareState)}).subscribe(result => {
            this.snackBar.open("Layout '" + resultData.dodLayout.name + "' Updated.", null, {
              duration: 5000
            });
          });
        });
      }
    })

    return false;
  }

  deleteLayout(layout: DodLayoutEx) {
    ConfirmDialogComponent.showDialog(this.dialog, "Confirm Delete", "Are you sure you want to delete this layout?")
      .subscribe(result => {
        if (result.ResultType == DialogResultType.Ok) {
          this.app.pushLoading("Deleting Layout...");
          this.dodService.dataOnDemandDeleteDataOnDemandLayout(layout.dodLayoutId).subscribe(_ => {
            this.app.refreshUserState(this.subscriptionService, () => {
              this.app.popLoading();
              this.refreshLayouts();
              this.snackBar.open("Layout '" + layout.name + "' Deleted.", null, {
                duration: 5000
              });
            });
          })
        }
      });

    return false;
  }

  createRecurring(layout: DodLayoutEx) {
    RecurringDodDialogComponent.showDialog(
      this.dialog,
    -1,
    layout.dodLayoutId,
    RecurringDodType.Weekly,
      0,
      1
    ).subscribe((result) => {
      if(result.ResultType == DialogResultType.Ok) {
        const results: RecurringDodDialogResult = result.ResultData;
        this.dodService.dataOnDemandCreateRecurringDod({
          dodRecurringId: -1,
          dodLayoutId: results.dodLayoutId,
          recurringType: results.recurringType,
          dayOfWeek: results.dayOfWeek,
          dayOfMonth: results.dayOfMonth
        }).subscribe((result) => {
          this.refreshLayouts();
          this.snackBar.open("Scheduled Export Saved.", null, {
            duration: 5000
          });
        });
      }
    });
    return false;
  }

  editRecurring(recurring: DodRecurring) {
    RecurringDodDialogComponent.showDialog(
      this.dialog,
      recurring.dodRecurringId,
      recurring.dodLayoutId,
      recurring.recurringType,
      recurring.dayOfWeek,
      recurring.dayOfMonth
    ).subscribe((result) => {
      if(result.ResultType == DialogResultType.Ok) {
        const results: RecurringDodDialogResult = result.ResultData;
        this.dodService.dataOnDemandUpdateRecurringDod({
          dodRecurringId: results.dodRecurringId,
          request: {
            dodRecurringId: results.dodRecurringId,
            dodLayoutId: results.dodLayoutId,
            recurringType: results.recurringType,
            dayOfWeek: results.dayOfWeek,
            dayOfMonth: results.dayOfMonth
          }
        }).subscribe((result) => {
          this.refreshLayouts();
          this.snackBar.open("Scheduled Export Updated.", null, {
            duration: 5000
          });
        });
      }
    });
    return false;
  }

  deleteRecurring(recurring: DodRecurring) {
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Delete",
      "Are you sure you want to delete this recurring export?"
    ).subscribe((result) => {
      if (result.ResultType == DialogResultType.Ok) {
        this.dodService.dataOnDemandDeleteRecurringDod(recurring.dodRecurringId).subscribe((result) => {
          this.refreshLayouts();
          this.snackBar.open("Recurring Export Deleted.", null, {
            duration: 5000
          });
        });
      }
    });
    return false;
  }

  exportNow(layout: DodLayoutEx) {
    let fileType = layout.fileTypeId;

    DataOnDemandDialogComponent.showDialog(this.dialog, fileType, layout.notificationEmail, layout.destinationId, layout.azureConfig, layout.awsConfig, layout.sftpConfig, layout.emailConfig).subscribe(result => {
      const resultData = result.ResultData as DataOnDemandDialogResult;
      this.dodService.dataOnDemandExportOnDemand({
        dodLayoutId: layout.dodLayoutId,
        fileTypeId: resultData.fileType,
        destinationId: resultData.destinationId,
        azureConfig: resultData.azureConfig,
        awsConfig: resultData.awsConfig,
        sftpConfig: resultData.sftpConfig,
        emailConfig: resultData.emailConfig,
        notificationEmail: resultData.notificationEmail
      }).subscribe(result => {
        this.refreshLayouts();
        this.snackBar.open("Export Submitted.", null, {
          duration: 5000
        });
      });
    })

    return false;
  }

  endPointChanged($event: MatSelectChange) {
    this.currentLayouts = this.allLayouts
      .filter(x => x.dodEndPointId == this.selectedEndPoint.dodEndPointId)
      .map(x => {
        return {
          ...x,
          exportStatus: 'Never Ran',
          latestUrl: undefined
        }
      })
    this.refreshJobs();
  }

  getExportStatus(status: DodExportStatus) : string {
    if (status.finishTime) {
      return 'Finished: ' + (new Date(status.finishTime + 'Z')).toLocaleString();
    } else {
      return status.lastStatus;
    }
  }
}

export interface LayoutDetails extends DodLayoutEx
{
  exportStatus: string | undefined;
}
